import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  forwardRef,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FormInput } from '../_form-input';

import { v4 as uuid } from 'uuid';
import {
  MatAutocomplete,
  MatAutocompleteTrigger,
} from '@angular/material/autocomplete';

@Component({
  selector: 'app-shared-form-input-text',
  templateUrl: './input-text.component.html',
  styleUrls: ['./input-text.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputTextComponent),
      multi: true,
    },
  ],
})
export class InputTextComponent implements FormInput, ControlValueAccessor {
  @Input() value: any;
  @Input() id: string = uuid();
  @Input() name: string = 'id';
  @Input() label: string = 'Input';
  @Input() placeholder?: string;
  @Input() mask?: string;

  @Input() error: string = '';

  @Input() type: string = 'text';
  @Input() disabled: boolean = false;
  @Input() readonly: boolean = false;

  @Input() passwordInput: boolean = false;

  @Input() autocompleteAnchor?: MatAutocomplete;

  /** If true, hide the label element */
  @Input() noLabel: boolean = false;

  /** Name of a material icon to show inside the input on the left */
  @Input() prefixIcon?: string;

  /** Size of the input. 'medium' uses the current 16px padding, 'small' uses reduced padding */
  @Input() size: 'medium' | 'small' = 'medium';

  visibleValue: boolean = false;

  @Output() onChange$: EventEmitter<any> = new EventEmitter<any>();
  @Output() onFocus$: EventEmitter<void> = new EventEmitter<void>();
  @Output() focusOut$: EventEmitter<void> = new EventEmitter<void>();
  @Output() enterPress: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild(MatAutocompleteTrigger, { static: false })
  autocompleteTrigger?: MatAutocompleteTrigger;

  onChange: any = () => {};
  onTouched: any = () => {};

  writeValue(value: any): void {
    if (value !== undefined) {
      this.value = value;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  emitChange(value: any): void {
    this.value = value;
    this.onChange(value);
    this.onChange$.emit(value);
  }

  emitFocus(): void {
    this.onTouched();
    this.onFocus$.emit();
  }

  emitFocusOut(): void {
    this.focusOut$.emit();
  }

  get matAutocompleteTrigger() {
    return this.autocompleteTrigger;
  }

  autoGrow(textarea: HTMLTextAreaElement) {
    textarea.style.height = 'auto';
    let lines = textarea.value.split('\n').length;
    if (lines > 2) lines = 2;
    textarea.rows = lines;

    const lineHeight = parseInt(
      window.getComputedStyle(textarea).lineHeight || '20',
      10
    );
    const maxHeight = lineHeight * 2 + 8;
    textarea.style.height =
      Math.min(textarea.scrollHeight + 4, maxHeight) + 'px';
    textarea.style.overflowY =
      textarea.scrollHeight > maxHeight ? 'auto' : 'hidden';
  }

  onTextareaKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.enterPress.emit();
    }
  }
}
